import './Sidebar.css'
import SidebarNav from '../SidebarNav/SidebarNav'
import SidebarFooter from '../SidebarFooter/SidebarFooter'
import SidebarHeader from '../SidebarHeader/SidebarHeader'
import {useContext, useEffect} from 'react'
import AppContext from "../../../contexts/AppContext";


export default function Sidebar() {
    const {isNavbarOpen} = useContext(AppContext);

    useEffect(() => {
        if (isNavbarOpen && window.innerWidth <= 1000) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isNavbarOpen]);

   return (
      <aside className={`sidebar-container ${isNavbarOpen ? 'sidebar-visible' : ''}`}>
            <section className='sidebar-content'>
                < SidebarHeader/>
                < SidebarNav/>
                < SidebarFooter/>
            </section>
        </aside>
    )
}
